import { render } from "./AdminTests.vue?vue&type=template&id=265e82d9&scoped=true&ts=true"
import script from "./AdminTests.vue?vue&type=script&lang=ts"
export * from "./AdminTests.vue?vue&type=script&lang=ts"

import "./AdminTests.vue?vue&type=style&index=0&id=265e82d9&scoped=true&lang=css"
import "./AdminTests.vue?vue&type=style&index=1&id=265e82d9&lang=css"
import "./AdminTests.vue?vue&type=style&index=2&id=265e82d9&lang=css"
import "./AdminTests.vue?vue&type=style&index=3&id=265e82d9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265e82d9"]])

export default __exports__